import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import LoaderPage from "src/components/Loader/LoaderPage";
import Tabs from "src/components/Tabs";
import useLoader from "src/hooks/useLoader";
import { getTalent } from "src/network/talent";
import Layout from "src/router/AuthenticatedRouter/Layout";
import { Talent } from "src/types";
import Profile from "./tabs/Profile";
import Resume from "./tabs/Resume";
import InviteModal from "../components/InviteModal";

export type TalentPageTab = "Profile" | "Resume";
export const tabs: TalentPageTab[] = ["Profile", "Resume"];

const TalentPage = () => {
  const { id } = useParams();
  const [talent, setTalent] = useState<Talent>();
  const fetchTalent = async () => {
    const t = await getTalent(Number(id));
    setTalent(t);
  };
  const { ldng } = useLoader(fetchTalent, { errorMsg: "Error fetching talent" });

  // Initial Fetch talent
  useEffect(() => {
    ldng();
  }, []);

  const inviteButton = talent ? <InviteModal talent={talent} /> : undefined;

  return (
    <Layout
      title={talent?.User.full_name || "Loading..."}
      back="/talent"
      rightChildren={inviteButton}
    >
      <div className="max-w-[1111px] mx-auto">
        {talent ? (
          <Tabs
            className="mb-6"
            tabs={tabs}
            withSearchParam
            contents={[<Profile t={talent} />, <Resume t={talent} />]}
          />
        ) : (
          <LoaderPage />
        )}
      </div>
    </Layout>
  );
};

export default TalentPage;
